import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import cx from 'classnames';

const TypeIcon = ({
  type, url, radius, className: propClassName, additionalStyles, iconLinkClass, target,
}) => {
  if (!type || !['related-article', 'slideshow', 'video', 'shop'].includes(type)) {
    return null;
  }

  const iconClasses = cx(
    'typeicon',
    propClassName,
    additionalStyles,
    'icon',
    {
      typeicon__radius: radius,
      'icon-dot': type === 'related-article',
      'icon-gallery': type === 'slideshow',
      'icon-video pointer-events-initial': type === 'video',
      'icon-shop': type === 'shop',
    },
  );

  if (url) {
    return (
      <Link className={iconLinkClass} to={url} target={target}>
        <span className={iconClasses} />
      </Link>
    );
  }

  return <span className={iconClasses} />;
};

TypeIcon.propTypes = {
  type: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]),
  url: PropTypes.string,
  radius: PropTypes.bool,
  className: PropTypes.string,
  additionalStyles: PropTypes.string,
  iconLinkClass: PropTypes.string,
  target: PropTypes.string,
};

TypeIcon.defaultProps = {
  type: false,
  url: null,
  className: null,
  additionalStyles: null,
  radius: false,
  iconLinkClass: null,
  target: null,
};

export default TypeIcon;
